interface LoadingSpinnerProps {
  label?: string;
  /** Fills the viewport -- used by route guards and Suspense fallbacks. */
  fullPage?: boolean;
  /** Render the spinner only, no visible text (collapsed sidebar). */
  iconOnly?: boolean;
}

export function LoadingSpinner({
  label = 'Loading...',
  fullPage = false,
  iconOnly = false,
}: LoadingSpinnerProps) {
  return (
    <div
      className={`loading-spinner${fullPage ? ' loading-spinner--page' : ''}`}
      role="status"
      aria-label={label}
    >
      <i className="pi pi-spinner pi-spin" aria-hidden="true" />
      {!iconOnly && <span>{label}</span>}
    </div>
  );
}
